import { Dispatch, ReactNode, SetStateAction, useCallback, useRef } from 'react';
import { Button } from 'primereact/button';
import { FieldValues } from 'react-hook-form';

import FormTypeCard from './FormTypeCard';
import AddEmailForm, { FormRef } from './AddEmailForm';

import freeformPreview from '../../assets/images/freeform-preview.png'
import form15620Preview from '../../assets/images/form15620-preview.png'

type PropTyps = {
  isPublic?: boolean;
  handleAddEmail?:(FormData: FieldValues) => void;
  isRegualarSelected: boolean;
  onSelect: Dispatch<SetStateAction<boolean>>;
  setFormTypeSelected:Dispatch<SetStateAction<boolean>>;
}

function FormTypeSelector(props: PropTyps): ReactNode {

  const {
    isPublic,
    onSelect,
    handleAddEmail,
    isRegualarSelected,
    setFormTypeSelected
  } = props;
  
  const formRef = useRef<FormRef>(null);

  const handlChooseForm = useCallback(async() => {
    if (formRef.current) {
      formRef.current.submit();
    } else {       
       setFormTypeSelected(true); 
    }
   

  }, [formRef]);

  return (
    <div className='flex flex-column gap-6'>
      <div className="w-full flex justify-content-between gap-4">
        <FormTypeCard
          isRegular
          previewImage={freeformPreview}
          icon='pi-file'
          title="Freeform Statement"
          description="This is a letter statement that lists the information required to make an 83(b) election. It was the commonly accepted means of filing an 83(b) election before the IRS published Form 15620."
          entityTypes={['Corporation','Public benefit corporation']}
          equityTypes={['Restricted stock']}
          isSelected={isRegualarSelected}
          onSelect={onSelect}
        />
        <FormTypeCard
          previewImage={form15620Preview}
          isRegular={false}
          icon='pi-file-edit'
          title="Form 15620"
          recommended
          description="This is the official IRS form for making an 83(b) election."
          entityTypes={['Corporation', 'Public benefit corporation', 'Limited liability company', 'Limited partnership','Other entity types']}
          equityTypes={['Restricted stock','Early exercised stock options','Profits Interests','Tokens','Other equity types']}
          isSelected={!isRegualarSelected}
          onSelect={onSelect}
        />
      </div>
      {
        (isPublic && !isRegualarSelected) ? (
            <AddEmailForm ref={formRef} onSubmitHandler={handleAddEmail}/>
        ) : null
      }
      <div className="text-right">
        <Button onClick={handlChooseForm}
                label={`Continue with ${isRegualarSelected ? 'Freeform Statement' : 'Form 15620'}`}/>
      </div>
    </div>
  )
}

export default FormTypeSelector;